import { ref } from 'vue';

// Module-scope state for Presidential. Lives outside the component so the open
// conversation, the list, and the Chanel thread survive navigating away and back.
// A full browser refresh resets it (and the server is the source of truth on load).

export const source = ref('suggested');   // 'suggested' | 'all'
export const items = ref([]);             // list rows (insights or conversations)

export const transcript = ref(null);      // open conversation thread
export const selectedConvId = ref(null);
export const reviewMsgId = ref(null);     // bot message under review
export const convFlags = ref({});         // botId → { verdict, reason }
export const resolved = ref({});          // messageId → true (resolved this session)

export const reviewTurn = ref(null);      // turn under review by Chanel
export const chanelMsgs = ref([]);        // operator ↔ Chanel chat
export const chanelInput = ref('');
export const proposal = ref(null);
export const chanelThreadId = ref(null);
